import React, { useEffect, useState } from 'react';
import { View, Dimensions, StyleSheet } from 'react-native';

export default function useSidebarStyle() {
	const { width, height } = Dimensions.get('window');
	const drawerType = width > 860 ? 'permanent' : 'front';
	const isLandscape = width > height;
	const [screenData, setScreenData] = useState({ drawerType, isLandscape });

	useEffect(() => {
		const onChange = result => {
			const drawerType = result.window.width > 860 ? 'permanent' : 'front';
			const isLandscape = result.window.width > result.window.height;
			if (drawerType != screenData.drawerType || isLandscape != screenData.isLandscape) setScreenData({ drawerType, isLandscape });
		};

		Dimensions.addEventListener('change', onChange);

		return () => Dimensions.removeEventListener('change', onChange);
	});

	return screenData;
}
